import { t } from 'i18next'
import React from 'react'
import {
  any,
  async,
  fromJSX,
  loadingAsyncState,
  nothing,
  onlyIf,
  router,
  StandardLocalWidget,
  unloadedAsyncState,
  Updater
} from 'widgets-for-react'
import { styleguide } from '../../styleguide/main.mod'
import { getCountryMenu, getHeader, getTopMenu } from '../drupal/api.mod'
import { requestDocuments } from './custom_pages/request_documents'
import { search_overview } from './custom_pages/search_overview'
import { SelectLocale } from './custom_pages/select_locale'
import { pageWidget } from './drupalPage/widget'
import { initialFooterState } from './footer/state'
import { footerWidget } from './footer/widget'
import { headerWidget } from './header/widget'
import { overviewWidget } from './overview/widget'
import { pressReleaseWidget } from './pressRelease/widget'
import { RouteState } from './route/state'
import { routesArray } from './route/utils'
import { PublicSiteState } from './state'
import { storyOverviewWidget } from './storyOverview/widget'
import { NotFoundPage } from './templates/error_page.mod'
import { convertEmToPx } from './utils/convertEmToPx'
import { getLangFromUrl } from './utils/history.mod'
import { ParadoxLoader } from './utils/paradoxLoader'
import { SalesViewerLoader } from './utils/salesViewerLoader'
import { vacancyDetailWidget } from './vacancies/vacancyDetail/widget'
import { PipedriveForm } from './utils/pipedrive-form'

export const add_project_title = (title: string) => {
  let title1 = title.toLowerCase().split(' ').join('')
  if (!title1?.startsWith('stone-')) {
    title = 'STONE - Interim & Detacheren - ' + title.replace(/%/g, '')
  }
  return title
}

export function updateMetaDescription(desc: string) {
  var elem = document.querySelector('meta[name="description"]')
  if (!elem) {
    elem = document.createElement('meta')
    document.getElementsByTagName('head')[0].appendChild(elem)
    elem.setAttribute('name', 'description')
  }
  elem.setAttribute('content', desc)
}

export const publicSiteWidget: StandardLocalWidget<PublicSiteState> = (s0) => {
  const lang = getLangFromUrl()
  const topMenuState =
    s0.header.topMenu.kind == 'unloaded' ? loadingAsyncState(() => getTopMenu(lang)) : s0.header.topMenu

  const countryMenuState =
    s0.header.countryMenu.kind == 'unloaded' ? loadingAsyncState(() => getCountryMenu(lang)) : s0.header.countryMenu

  const navLinksState =
    s0.header.menuHeader.navLinks.kind == 'unloaded'
      ? loadingAsyncState(() => getHeader(lang))
      : s0.header.menuHeader.navLinks

  const refrescoBranding =
    s0.route.kind == 'drupalPage' &&
    s0.route.page.kind == 'loaded' &&
    s0.route.page.value.node.bundle == 'page' &&
    s0.route.page.value.node.field_refresco_branding

  return any<Updater<PublicSiteState>>([
    router<Updater<PublicSiteState>>()(routesArray),
    fromJSX(() => <SalesViewerLoader />),
    fromJSX(() => <ParadoxLoader />),
    async(s0.departments).map(
      (updater) =>
        (state): PublicSiteState => ({ ...state, departments: updater(state.departments) })
    ),
    async(s0.countries).map(
      (updater) =>
        (state): PublicSiteState => ({ ...state, countries: updater(state.countries) })
    ),
    async(navLinksState).map(
      (updater) =>
        (state): PublicSiteState => ({
          ...state,
          header: {
            ...state.header,
            menuHeader: { ...state.header.menuHeader, navLinks: updater(state.header.menuHeader.navLinks) }
          }
        })
    ),
    // FIXME: unused? languages are always unloaded
    async(s0.header.menuHeader.languages).map(
      (updater) =>
        (state): PublicSiteState => ({
          ...state,
          header: {
            ...state.header,
            menuHeader: { ...state.header.menuHeader, languages: updater(state.header.menuHeader.languages) }
          }
        })
    ),
    async(topMenuState).map(
      (updater) =>
        (state): PublicSiteState => ({ ...state, header: { ...state.header, topMenu: updater(state.header.topMenu) } })
    ),
    async(countryMenuState).map(
      (updater) =>
        (state): PublicSiteState => ({
          ...state,
          header: { ...state.header, countryMenu: updater(state.header.countryMenu) }
        })
    ),
    s0.route.kind == 'styleguide' || s0.route.kind == 'selectLocale'
      ? nothing()
      : headerWidget(
          (s0.route.kind == 'search_overview' && s0.route.slug == 'search') ||
            (s0.route.kind == 'overview' && s0.route.slug == 'vacancies') ||
            s0.route.kind == 'press' ||
            s0.route.kind == 'vacancyDetail' ||
            (s0.route.kind == 'drupalPage' &&
              s0.route.page.kind == 'loaded' &&
              s0.route.page.value.node.bundle == 'story')
            ? false
            : true,
          refrescoBranding
        )(s0.header).map(
          (updater) =>
            (state): PublicSiteState => ({ ...state, header: updater(state.header) })
        ),
    pageSwitch(s0).map(
      (updater) =>
        (state): PublicSiteState => ({ ...state, ...updater(state) })
    ),
    onlyIf(
      s0.route.kind != 'styleguide' && s0.route.kind != 'selectLocale',
      footerWidget(refrescoBranding)(s0.footer).map(
        (updater) =>
          (state): PublicSiteState => ({ ...state, footer: updater(state.footer) })
      )
    )
  ]).map((updater) => (state): PublicSiteState => {
    const newState = updater(state)

    if (newState.route != s0.route) newState.header.mode == 'closed'

    if (window.innerWidth < convertEmToPx(64))
      document.documentElement.classList.toggle('nav--toggled', newState.header.mode == 'open')
    else document.documentElement.classList.remove('nav--toggled')

    const lang = getLangFromUrl()

    if (newState.header.currentLanguage != lang) {
      newState.header.currentLanguage = lang
      newState.header.topMenu = unloadedAsyncState()
      newState.header.countryMenu = unloadedAsyncState()
      newState.header.menuHeader.navLinks = unloadedAsyncState()
      newState.footer = initialFooterState()
    }

    newState.route.kind == 'selectLocale' && (window.document.title = t('SelectLocale:titleBrowserTab'))
    newState.route.kind == 'requestDocuments' && (window.document.title = t('BimAndDrawingsForm:Texts.BrowserTab'))
    newState.route.kind == 'storyOverview' && (window.document.title = 'Stories | Refresco')

    if (shouldScroll(state.route, newState.route)) {
      closeJobPostingDiv()
      newState.header.mode = 'closed'
      window.scrollTo(0, 0)
    }

    window.document.body.setAttribute('data-menustate', newState.header.mode)
    return newState
  })
}

const shouldScroll = (oldRoute: RouteState, newRoute: RouteState): boolean =>
  oldRoute.kind == 'overview' && newRoute.kind == 'overview'
    ? oldRoute.slug != newRoute.slug
    : oldRoute.kind == 'drupalPage' && newRoute.kind == 'drupalPage'
    ? oldRoute.slug != newRoute.slug
    : newRoute.kind != oldRoute.kind

const closeJobPostingDiv = () => {
  let jp_api = document.getElementById('job_posting')
  if (jp_api) jp_api.replaceWith(createWithId('job_posting'))
}

const createWithId = (id: string) => {
  let element = document.createElement('div')
  element.id = id
  return element
}

const pageSwitch: StandardLocalWidget<PublicSiteState> = (state) => {
  const route = state.route
  switch (route.kind) {
    case 'ignore': {
      return nothing()
    }
    case '404': {
      return fromJSX(() => <NotFoundPage />)
    }
    case 'pipedriveForm': {
      return fromJSX((setState) => (
        <main id="a11y-main" className="main main--page">
          <div className="main__inner">
            <article className="page">
              <div className="page__inner">
                <header className="pageheader">
                  <div className="pageheader__inner">
                    <div className="pageheader__content container container--m">
                      <div className="pageheader__message">
                        <div className="pageheader__header">
                          <h1 className="pageheader__title">Pipedrive form</h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </header>
                <div className="page__content">
                  <PipedriveForm />
                </div>
              </div>
            </article>
          </div>
        </main>
      ))
    }
    case 'drupalPage': {
      return pageWidget(
        state.departments.kind == 'loaded' ? state.departments.value : [],
        state.countries.kind == 'loaded' ? state.countries.value : []
      )(route).map(
        (updater) =>
          (state): PublicSiteState =>
            state.route.kind == 'drupalPage' ? { ...state, route: { ...state.route, ...updater(state.route) } } : state
      )
    }
    case 'styleguide': {
      return styleguide.never()
    }
    case 'selectLocale': {
      return fromJSX(() => <SelectLocale />)
    }
    case 'requestDocuments': {
      return requestDocuments(state.requestDocuments).map(
        (updater) =>
          (state): PublicSiteState => ({ ...state, requestDocuments: updater(state.requestDocuments) })
      )
    }
    case 'storyOverview': {
      return storyOverviewWidget(route.lang)(route).map(
        (updater) =>
          (state: PublicSiteState): PublicSiteState =>
            state.route.kind == 'storyOverview'
              ? { ...state, route: { ...state.route, ...updater(state.route) } }
              : state
      )
    }
    case 'press': {
      return pressReleaseWidget(state.press).map(
        (updater) =>
          (state: PublicSiteState): PublicSiteState => ({ ...state, press: updater(state.press) })
      )
    }
    case 'search_overview': {
      return search_overview([route, state.search_overview]).map(
        (updater) =>
          (state: PublicSiteState): PublicSiteState => ({ ...state, search_overview: updater(state.search_overview) })
      )
    }
    case 'overview': {
      return overviewWidget(route).map(
        (updater) =>
          (state: PublicSiteState): PublicSiteState =>
            state.route.kind == 'overview' ? { ...state, route: { ...state.route, ...updater(state.route) } } : state
      )
    }
    case 'vacancyDetail': {
      return vacancyDetailWidget(
        route.success,
        getLangFromUrl()
      )(route).map(
        (updater) =>
          (state): PublicSiteState =>
            state.route.kind == 'vacancyDetail'
              ? { ...state, route: { ...state.route, ...updater(state.route) } }
              : state
      )
    }
  }
}
